import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es7.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { call, get } from 'vuex-pathify';
import { maxLength, minLength, numeric, required, sameAs } from 'vuelidate/lib/validators';
import { alphaNumDashes, alphaNumLower } from "../../functions/validators";
import { FIB } from "../../config/constants";
import { version } from "../../../package.json";
var MAX_PASSCODE_LENGTH = FIB.MAX_PASSCODE_LENGTH,
    MIN_PASSCODE_LENGTH = FIB.MIN_PASSCODE_LENGTH;
export default {
  name: 'DeviceSettings',
  components: {
    FibCommonModal: require("../../components/CommonModal.vue").default
  },
  props: {
    mode: {
      required: true,
      type: String,
      validator: function validator(value) {
        return ['register', 'update'].includes(value);
      }
    },
    popup: {
      type: Boolean
    },
    value: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      // Form fields
      branchId: '',
      companyKey: '',
      deviceId: '',
      passcode: '',
      settingsPasscode: '',
      settingsPasscodeConfirm: '',
      // Dialogs
      showSuccess: false,
      showWait: false,
      // Other
      version: version
    };
  },
  computed: {
    logo: get('theme/baseTheme@logoColor'),
    primary: get('theme/baseTheme@primaryColor'),
    supportedDevice: get('app/supportedDevice'),
    isAppNotTesting: function isAppNotTesting() {
      return this.$store.get('config/isApp') && !process.env.PWA_TESTING;
    },
    register: function register() {
      return this.mode === 'register';
    },
    template: function template() {
      return this.popup ? 'fib-modal' : {
        template: "<div class=\"box\"><slot /></div>"
      };
    }
  },
  methods: {
    beforeHide: function beforeHide() {
      // Clear field data
      this.deviceId = '';
      this.settingsPasscode = '';
      this.settingsPasscodeConfirm = '';
    },
    beforeShow: function beforeShow() {
      /*
       * Add any code here that should happen just before the dialog is displayed, such as
       * pre-populating field data (such as Device ID if/when this can be edited)
       */
    },
    changeSettingsPasscode: call('config/changeSettingsPasscode'),
    done: function done() {
      this.$emit('input');
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.isAppNotTesting && !_this.supportedDevice)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                // Attempt to register device or change settings passcode
                Logger.debug(_this.register ? 'Attempt to register device' : 'Attempt to change settings passcode');
                _this.showWait = true;
                result = null;

                if (!_this.register) {
                  _context.next = 17;
                  break;
                }

                // Persist form data to store
                _this.$store.set('config/branchId', _this.branchId);

                _this.$store.set('config/companyKey', _this.companyKey);

                _this.$store.set('config/deviceId', _this.deviceId);

                _this.$store.set('config/passcode', _this.passcode);

                _this.$store.set('settings/passcode', _this.settingsPasscode);

                _context.next = 13;
                return _this.registerDevice();

              case 13:
                result = _context.sent;

                _this.$store.set('config/registered', result && !result.error);

                _context.next = 21;
                break;

              case 17:
                _context.next = 19;
                return _this.changeSettingsPasscode(_this.settingsPasscode);

              case 19:
                result = _context.sent;

                if (result && !result.error) {
                  _this.$store.set('settings/passcode', _this.settingsPasscode);
                }

              case 21:
                _this.showWait = false; // Registration or update failed

                if (!result.error) {
                  _context.next = 25;
                  break;
                }

                Logger.warn(_this.register ? 'Registration failed' : 'Change settings passcode failed');
                return _context.abrupt("return");

              case 25:
                // Registration or update successful
                Logger.debug(_this.register ? 'Registration successful' : 'Change settings passcode successful');
                _this.showSuccess = true;

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    registerDevice: call('config/registerDevice'),
    resetValidation: function resetValidation(field) {
      if (this.$refs[field]) {
        this.$refs[field].resetValidation();
      }

      return true;
    },
    validate: function validate(field) {
      if (this.$refs[field]) {
        return this.$refs[field].validate();
      }

      return true;
    }
  },
  validations: function validations() {
    return {
      branchId: {
        maxLength: maxLength(12),
        numeric: numeric,
        required: required
      },
      companyKey: {
        alphaNumLower: alphaNumLower,
        maxLength: maxLength(32),
        required: required
      },
      deviceId: {
        alphaNumDashes: alphaNumDashes,
        maxLength: maxLength(64),
        minLength: minLength(3),
        required: required
      },
      passcode: {
        alphaNumLower: alphaNumLower,
        maxLength: maxLength(5),
        minLength: minLength(5),
        required: required
      },
      settingsPasscode: {
        maxLength: maxLength(MAX_PASSCODE_LENGTH),
        minLength: minLength(MIN_PASSCODE_LENGTH),
        numeric: numeric,
        required: required
      },
      settingsPasscodeConfirm: {
        required: required,
        sameAsPasscode: sameAs('settingsPasscode')
      },
      validationGroup: this.register ? ['branchId', 'companyKey', 'deviceId', 'passcode', 'settingsPasscode', 'settingsPasscodeConfirm'] : ['settingsPasscode', 'settingsPasscodeConfirm']
    };
  }
};